import { ChangeDetectorRef, Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { InvoiceData, InvoiceMetadata, InvoiceResponse } from 'src/app/shared/model/invoice.model';
import { InvoiceService } from 'src/app/core/services/invoice.service';
import httpErrorCodes from 'src/app/core/common/http_error_codes';
import { STATUSES } from 'src/app/shared/constants/common.constants';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-invoice-popup',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    DialogModule,
    HttpClientModule,
    CardModule,
    TableModule,
    ButtonModule,
  ],
  providers: [TranslateService],
  animations: [],
  templateUrl: './invoice-popup.component.html',
  styleUrl: './invoice-popup.component.scss',
})
export class InvoicePopupComponent implements OnChanges {
  @Input() invoiceId!: number | null;

  @Input() showInvoicePopup!: boolean;

  @Output() closePopup = new EventEmitter<void>();

  invoiceData: InvoiceResponse['data'] | null = null;

  paymentRecords: InvoiceData['paymentRecords'] | [] = [];

  invoiceMetadata: InvoiceData['invoiceMetadata'] | null = null;

  callDetails: InvoiceData['callDetails'] | null = null;

  costComponent: InvoiceMetadata['costComponents'] | [] = [];

  loading = true;

  constructor(
    private cdRef: ChangeDetectorRef,
    private invoiceService: InvoiceService,
    private translateService: TranslateService,
    private toastService: ToasterService,
  ) {}

  ngOnChanges() {
    if (this.invoiceId) {
      this.loadInvoiceDetails(this.invoiceId);
      this.loading = false;
    }
  }

  onClosePopup(): void {
    this.showInvoicePopup = false;
    this.closePopup.emit();
    this.cdRef.detectChanges();
  }

  formatDuration(minutes: number): string {
    return CommonService.formatDuration(minutes);
  }

  getConvertedDate(utcDate: string) {
    return CommonService.getFormattedDate(utcDate);
  }

  loadInvoiceDetails(id: number) {
    this.invoiceService.getInvoiceDetailsById(id).subscribe({
      next: (response) => {
        if (response.status === STATUSES.SUCCESS) {
          this.invoiceData = response.data;
          this.paymentRecords = this.invoiceData.paymentRecords;
          this.callDetails = this.invoiceData.callDetails;
          this.invoiceMetadata = this.invoiceData.invoiceMetadata;
          this.costComponent = this.invoiceData.invoiceMetadata.costComponents;
        }
      },
      error: (err) => {
        if (err.status !== httpErrorCodes.NOT_FOUND) {
          this.toastService.showErrorToast(
            this.translateService.instant(
              'INVOICE_POPUP.TOAST_MESSAGE.FAILED_TO_LOAD_INVOICE_DATA',
            ),
          );
        }
      },
    });
  }
}
